// File: src/layouts/NoContainer.js
// requirement in layoutConfig (App.js)

import { useLocation } from "react-router-dom";

export default function NoContainer({ children }) {
  const location = useLocation();
  const isApplicantWorkspace = location.pathname.startsWith("/dashboard/applicant");

  return <div className={`min-h-screen px-5 ${isApplicantWorkspace ? "pt-0" : "pt-20"}`}>{children}</div>;
}
